import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // For carousel functionality
import './index.css'; // Your custom styles

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <App />
);